import React, { FC, useMemo } from 'react';
import { ReactComponent as MenuIcon } from 'assets/icons/menu.svg';

import { ENUM_LIVE_CARD_MENU, LiveCardListType } from '../menu-config';
import { Dropdown } from '@cokitchen/cokitchen-components';
import { OrderType } from 'models/order.model';
import { getKitchenOrderStatus, getOrderStatus } from 'utils/functions';
import OrderStatus from 'components/base/order-status';
import { getCokitchenTeam } from 'utils/role-config';
import OrderTag from 'components/base/order-tag';
import { ENUM_COKITCHEN_TEAM } from '@cokitchen/cokitchen-auth';
import { ENUM_STATUS } from 'utils/enum';
import RecallOrderTag from 'components/recall-order-tag';
import { withDropdownList } from 'components/base/dropdown-list';
import { getLiveCardMenuList } from '../util';
import OrderDeliveryProvider from 'components/base/order-delivery-provider';

type LiveTripCardType = {
  order: OrderType;
  onSelectMenu: (menuKey: ENUM_LIVE_CARD_MENU) => void;
  ridersAvailable: boolean;
};

const DropdownList = withDropdownList<LiveCardListType>();

const BaseLiveTripCardHeader: FC<LiveTripCardType> = ({ order, onSelectMenu, ridersAvailable }) => {
  const currentTeam = getCokitchenTeam();

  const type =
    currentTeam === ENUM_COKITCHEN_TEAM.KITCHEN
      ? getKitchenOrderStatus(order)
      : getOrderStatus(order);

  const lateOrder =
    order.paid &&
    (order.kitchen_time_elapsed ||
      (order?.estimated_delivery_time
        ? new Date(order.estimated_delivery_time).getTime() < new Date().getTime()
        : false));

  const isRecalled =
    order?.order_logs?.find((log) => log.action === 'order_recalled') &&
    getOrderStatus(order) !== ENUM_STATUS.RECALLED;

  const list = useMemo(() => {
    return getLiveCardMenuList(order, ridersAvailable);
  }, [order, ridersAvailable]);

  return (
    <div className='px-4 flex justify-between items-center'>
      <div className='flex gap-1 flex-col items-start'>
        <span className='flex gap-2 items-center'>
          <OrderDeliveryProvider order={order} />
          <OrderStatus type={type} />
        </span>
        {lateOrder && <OrderTag type='late' />}
      </div>
      <div className='flex items-center gap-x-4'>
        {isRecalled && <RecallOrderTag />}
        {type !== 'complete' && list.length > 0 && (
          <span onClick={(e) => e.stopPropagation()}>
            <Dropdown
              content={
                <MenuIcon className='bg-[#FEF0F2] w-7 h-7 p-[7px] rounded-full cursor-pointer transition-all duration-200 hover:bg-red-3' />
              }>
              <DropdownList list={list} onSelect={(item) => onSelectMenu(item.key)} />
            </Dropdown>
          </span>
        )}
      </div>
    </div>
  );
};

export default BaseLiveTripCardHeader;
